// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { main } from './router';
import store from './store'
import './assets/bootstrap-grid.min.css'
import './assets/bootstrap-reboot.min.css'
import './assets/default-skin.css'
import './assets/ionicons.min.css'
import './assets/jquery.mCustomScrollbar.min.css'
import './assets/magnific-popup.css'
import './assets/main.css'
import './assets/nouislider.min.css'
import './assets/owl.carousel.min.css'
import './assets/photoswipe.css'
import './assets/plyr.css'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    data: {
        vipInfo: "0",
        subInfo: null,
        user_id: "",
        movieInfo: null
    },
    router: main,
    beforeCreate() {
        Vue.prototype.$bus = this
    },
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js